import React, { useState, useCallback, useEffect, Fragment } from 'react';
import axios from "axios";
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row, Col, Form, FormGroup, Button,
    Label, Input, FormText
} from "reactstrap";
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';

const NewordeStep1 = (props) => {
    let textInput = React.createRef();
    const { nextStep, changeText } = props;
    const { fetchCustomer, fetchDetails } = props;
    const [orderType, setOrderType] = useState({ value: "0", label: "Select Delivery Type" });
    const [outlet, setOutlet] = useState({ value: "0", label: "Select Outlet" });
    const [outletList, setOutletList] = useState([]);
    useEffect(() => {
        const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: 'https://api.chicking-malappuram.in/api/outlets/',
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            console.log("res", res)
            setOutletList(res.data);
        });
    }, [])
    const next = (e) => {
        e.preventDefault();
        nextStep();
    }
    const fetchcu = (e) => {
        e.preventDefault();
        fetchCustomer();
    }
    const handelChangeSelect = (e) => {
        localStorage.setItem("orderType", [e.value]);
        setOrderType({ value: e.value, label: e.label });
    }
    const handelChangeOutlet = (e) => {
        localStorage.setItem("outlet", [e.value]);
        localStorage.setItem("outletname", [e.label]);
        setOutlet({ value: e.value, label: e.label })
    }
    const optionOrderType = [
        { value: "0", label: "Select Delivery Type" },
        { value: "delivery", label: "Delivery" },
        { value: "self_collect", label: "Come and Collect" }
    ];
    let optionOutletList = [];
    outletList && outletList.length > 0 &&
        outletList.map((data) => {
            let newList = { value: data.id, label: data.location };
            optionOutletList.push(newList);
        })
    function handleClick() {
        const access = sessionStorage.getItem('access');
        alert(textInput.current.value)
        // alert(this.state.customerNumber)
        // axios({
        //     method: 'get',
        //     url: `https://api.chicking-malappuram.in/api/orders/?phone=${textInput.current.value}`,
        //     headers: { 'Authorization': `Bearer ${access}` }
        // }).then((res) => {
        //     console.log("res", res)
        //     if (res.data.length > 0) {
        //         setOrderDetails(res.data);
        //         let pageCount = res.data[0].page_count;
        //         let totalCount = (parseInt(pageCount) * 6);
        //         setItemTotalCount(totalCount);
        //         console.log("getOrderList -> pageCount", pageCount)
        //     }
        //     setloading(false)

        // });
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card className="demo-icons">
                            <CardHeader>
                                <CardTitle tag="h5">Step 1: Name and Contact Number</CardTitle>
                            </CardHeader>
                            <CardBody className="all-icons">
                                <div style={{ maxWidth: 600, margin: "0 auto" }}>
                                    <FormGroup>
                                        <Row>
                                            <Col md="8">
                                                <Label for="exampleEmail">Contact Number</Label>
                                                <Input ref={textInput} type="text" value={props.number} name="customerNumber" onChange={changeText} id="exampleEmail" placeholder="Contact Number" />
                                            </Col>
                                            <Col md="4">
                                                <Button onClick={fetchcu} style={{ marginTop: 23 }}>Fetch Customer</Button>
                                            </Col>
                                        </Row>

                                        <br></br>
                                        <Label for="exampleEmail">Name</Label>
                                        <Input type="text" name="customerName" value={props.name} onChange={changeText} id="exampleEmail" placeholder="Name" />
                                        <br></br>
                                        <InputLabel id="demo-simple-select-label">Order Type</InputLabel>
                                        <Select

                                            value={orderType}
                                            onChange={e => handelChangeSelect(e)}
                                            options={optionOrderType}
                                        />
                                        <br></br>
                                        <InputLabel id="demo-simple-select-label">Outlet</InputLabel>
                                        <Select
                                            value={outlet}
                                            onChange={e => handelChangeOutlet(e)}
                                            options={optionOutletList}
                                        />
                                        <br></br>
                                        <TextField style={{ width: "100%" }}
                                            id="outlined-multiline-static"
                                            label=""
                                            multiline
                                            rows={2}
                                            value={props.address}
                                            onChange={props.changeText}
                                            name="customerAddress"
                                            variant="outlined"
                                            placeholder="address"
                                        />
                                        <Button className="btn btn-chick pull-right" onClick={next}>Next</Button>
                                    </FormGroup>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );

}

export default NewordeStep1;
